import React from 'react';
import ProductImage from "./ProductImage";
import Heading from "../elements/Heading";

const ProductDetails = (props) => {

    const LeadCopy = props.product.details.leadCopy.map((item, key) => {
        return (
            <p key={key}>{item}</p>
        );
    });

    let SecondItems;
    if (props.product.details.secondItems) {
    	SecondItems = <ul>
			{props.product.details.secondItems.map((item, key) => {
				return (
					<li key={key}>{item}</li>
				);
			})}
		</ul>;
	}
    
    return (
        <div className="product-details">
            <div className="inner reverse">
                <div className="row">
                    <div className={( props.product.image ? 'col-md-5 col-md-offset-1 col-xs-12' : 'col-md-10 col-md-offset-1 col-xs-12' )}>
                        <Heading title={props.product.details.title} subTitle={props.product.details.subTitle} />
                        {LeadCopy}
                        <h2>{props.product.details.secondTitle}</h2>
						{SecondItems}
                    </div>
                    {(props.product.image ?
                        <div className="col-md-5 col-xs-12">
                            <ProductImage
                                title={props.product.imageTitle}
                                image={props.product.image}
                                price={props.product.price}
                                terms={props.product.terms}
                            />
                        </div>
                    : '')}
                </div>
                {props.children}
            </div>
            <div className={props.bottomWave} />
        </div>
    );
    
};

export default ProductDetails;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ProductDetails.js